import { render, staticRenderFns } from "./AddressValue.vue?vue&type=template&id=e2ec45fc"
import script from "./AddressValue.vue?vue&type=script&lang=js"
export * from "./AddressValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports